module.exports = {

  title: '公卫辅助及慢病健康管理系统',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * 主题类型
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  themeType: 'theme-theme3'
}



// WEBPACK FOOTER //
// ./src/settings.js